import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';

export class CouponsBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Coupons;

  get Icon(): React.ComponentType<SvgIconProps> {
    return LocalOfferIcon;
  }
}
